const NavSection = ({ title, children, className = '' }) => {
  return (
    <div className={`mb-2 ${className}`}>
      {title && (
        <div className="text-2xs font-semibold text-slate-400 dark:text-slate-400 uppercase tracking-wider px-3 pt-4 pb-1">
          {title}
        </div>
      )}
      <div className="space-y-1">{children}</div>
    </div>
  );
};

export default NavSection;
